export default __webpack_public_path__ + "2285773e6b4b172f07d9b777c81b0775.woff";